/**
 * Angular imports.
 */
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/**
 * Service imports.
 */
import { AuthService } from '../../auth/auth.service';
import { LocalstorageService } from '../../auth/localstorage.service';
import { EncryptionService } from '../../auth/encryption.service';
import { EventMsgService } from '../../dataservices/master-service/event-msg.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { DefaultMediaService } from '../../dataservices/defaultthumbnail/default-media.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { AnalyticsEventService } from './../../analytics-event/analytics-event.service';
/**
 * Rxjs imports.
 */
import { Subject, Subscription } from 'rxjs';
/**
 * Constant imports.
 */
import { NUMBERS, GRADIENT_DIRECTION, CALLING_FROM, COMMENT_LIST_TYPE, PRODUCT_TYPE_CONSTANT, REPOST_STATUS, SCREEN_NAME, ARTICLE_TUTORIAL_LOCAL_STORAGE, REPOST_INFO_LOCAL_STORAGE, POSTING_PROGRESS, REPOST_TYPE_ITEM, STORY_CREATION_TYPE, CREATE_STORY_TYPES, TEMPLATE_TYPE, USER_STORY_NUDGE, PRODUCT_TYPE_CONSTANT_NAME, CTA_TYPE, ACTION_TYPE, ACTION_ON, PRODUCT_TYPE_NUMBER_MAPPING, MEDIA_TYPE } from './../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
import { CLICK, CLICK_SUB, LIKE } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../analytics-event/analytics.model';
import { PostedIn, userComment } from '../../onboarding/interface/global.model';


/**
 * import sdk
 */
import { Analytics } from 'analytics2.0';

/**
 * FeedCard Component.
 */
@Component({
  selector: 'app-feed-card',
  templateUrl: './feed-card.component.html',
  styleUrls: ['./feed-card.component.scss']
})
export class FeedCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() callingfrom;
  @Output() deleteFeedIdx = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() feedObj: any;
  @Input() feedIdx;
  @Input() source;
  @Input() channelInfo;
  @Input() ptoductType;
  @Input() textHeighlight;
  @Input() flags;
  @Input() isCommunityAdmin = false;
  @Input() communityId;

  @Input() parentFeedId;
  /**
   * EC id if user open it from ec card.
   */
  @Input() ecId?: number;
  /**
   * Output is used to emit feed post specialty with card.
   * Emits delete feed event in a community by admin
   */
  @Output() feedSpecialty = new EventEmitter();
  @Output() emitDeleteCommunityFeed = new EventEmitter();

  /**
   * Emit user comment data.
   */
  public emitUserComment: userComment;

  /**
   * Variable used to store numeric values.
   */
  public numbers = NUMBERS;
  public productType = PRODUCT_TYPE_CONSTANT;

  public channelComment = true;
  public openMediaIndex = 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public meta_array: any;
  public mediaModal = false;
  public showLikeListModal = false;
  public activate_post_modal_flag = false;
  public isConfirmModalShown = false;
  public showSubscribeModal = false;
  public isGetsampleModal = false;
  public feedlistModal = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feedObject: any;
  public bookmarkObj;
  public followObj;
  public likeObj; // Like Component Object
  public commentObj; // Comment Component Object
  public loginUserCustomeId: string;
  public profilePicPath = '';
  public confirmInfo: string;
  public is_bookmark = false;
  public is_follow = false;
  public tooltip_ass = '';
  public showComment = false;
  public see_more = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public subscribe_obj: any;
  public youtubeUrl = '';
  public youtubeId = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public iframe_html: any;
  public hide_youtube_thumbnail = false;
  public isErrorModalShown = false;
  public error_msg: string;
  public screen_name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public media_source: any;
  public feed_like_loader = false;
  public feed_bookmark_loader = false;
  public feed_channel_follow_loader = false;
  public feedDetailModal = false;
  public mediaIdx = 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userProfileData: any;
  public offset = 1;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public channelDetail: any;
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };
  public is_activity = false;
  public product_like_in_process = false;
  public comment_box_obj = { profile_pic: '', product_type_id: '', product_id: '' };
  public channelsub: object = {};
  /**
   * isDeleteConfirmModalStep1 flag to show step1 of confirmation process
   * isDeleteConfirmModalStep2 flag to show step2 of confirmation process
   * deleteConfirm contains cancel button and confirm button text
   */
  public isDeleteConfirmModalStep1 = false;
  public isDeleteConfirmModalStep2 = false;
  public deleteConfirm = { cancelBtnText: '', confirmBtnText: '' };

  /**
   * Key used to get comment list type.
   */
  public commentListType = COMMENT_LIST_TYPE;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Check the status of post button.
   */
  public isPostButtonDisable = false;

  /**
   * Gradient direction constant
   *
   * @memberof FeedCardComponent
   */
  public gradientDirection = GRADIENT_DIRECTION;
  /**
   * Analytics for feed bookmark var.
   */
  public analyticsBookmarkData: AnalyticsInterface;
  /**
   * Analytics for specilaztion var.
   */
  public analyticsSpecializationData: AnalyticsInterface;
  /**
   * Analytics for feed var.
   */
  public analyticsFeedData: AnalyticsInterface;
  /**
   * Analytics for feed share.
   */
  public analyticsShareData: AnalyticsInterface;
  /**
   * Analytics for feed view more.
   */
  public analyticsFeedViewMoreData: AnalyticsInterface;
  /**
   * Analytics for feed data.
   */
  public analyticsFeedLikeData: AnalyticsInterface;
  public analyticsViewMoreData: AnalyticsInterface;
  public analyticsPollOption: AnalyticsInterface;
  public analyticsImageData: AnalyticsInterface;
  public analyticsDocumentData: AnalyticsInterface;
  /**
   * Session time for analytics.
   */
  public sessiontime = { 'start_time': '', 'end_time': '' };

  /**
   * notifier subject to destory streams
   */
  private notifier$ = new Subject();
  /**
   * Create post screen name.
   */
  public createRepostScreen = SCREEN_NAME.CREATE_REPOST;
  /**
   * create user story screen
   */
  public createUserStoryScreen = SCREEN_NAME.CREATE_USER_STORY;
  /**
   * Repost info popover status.
   */
  public showRepostPopOver = false;
  /**
   * Product type constant.
   */
  public productTypeConstant = PRODUCT_TYPE_CONSTANT;

  /**
   * Screen name constant
   */
  public screenName = SCREEN_NAME;
  /**
   * post meta flag
   */
  public isMetaGenerated = false;

  public productTypeConstantName=PRODUCT_TYPE_CONSTANT_NAME
  /**
  * Necessary imports.
  */
  constructor(
    public igs: ImageGroupService,
    public ems: EventMsgService,
    public funCollectionService: FunCollectionService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorage: LocalstorageService,
    private masterService: MasterserviceService,
    public defaultMediaService: DefaultMediaService,
    public postSer: PostApiService,
    private jwtSer: JwtDecodeService,
    private dss: DataStorageService,
    public mls: NewLanguageService,
    private encrypt: EncryptionService,
    private analyticSdk: Analytics,
    private analyticsEventService: AnalyticsEventService
  ) {

    this.loginUserCustomeId = this.authService.getbyName('profile_obj');
    if (sessionStorage.getItem('userProfileData') != null) {
      this.userProfileData = (JSON.parse(this.encrypt.decryptAes(this.localStorage.getInSessionStorage('userProfileData'))));
    }
    this.screen_name = this.route.snapshot.data['screen_name'];


    this.subscriptions.add(this.dss.feed_detail_action.subscribe(data => {
      if (data.feed_id == this.feedObject.feed_id) {
        this.is_activity = !this.is_activity;
        this.feedObject = data;
        this.feedObj = data;
        this.commentObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'comment': this.feedObject['feed_comment_list'], 'total_comment': this.feedObject['total_comments'], 'kind': this.feedObject['feed_kind'] };
      }
    }));
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    if (this.feedObj.channel != undefined && this.feedObj.channel.is_subscribed == 0 && this.feedObj.channel.is_product_view == 0 && this.feedObj.comment_flag == 1) {
      this.channelComment = false;
    }
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {

    this.feedObject = this.feedObj;
    this.comment_box_obj.product_type_id = '1';
    this.comment_box_obj.product_id = this.feedObject.feed_id;

    if (this.feedObject.user_profile == null) {
      if (this.feedObject.channel != null) {
        // No Code
      }
    }
    this.getFeedAssociationList();
    if (this.feedObject['feed_comment_list']?.length > 0) {
      this.showComment = true;
      this.commentObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'comment': this.feedObject['feed_comment_list'], 'total_comment': this.feedObject['total_comments'], 'kind': this.feedObject['feed_kind'] };
    } else {
      this.showComment = false;
      this.commentObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'comment': [], 'total_comment': this.feedObject['total_comments'], 'kind': this.feedObject['feed_kind'] };
    }

    this.subscriptions.add(this.dss.subscribeFeedChannelCard.subscribe(data => {
      if (data == 'feedChannelSubscribed') {
        this.feedObj.channel.is_subscribed = 1;
        this.feedObj.channel.is_product_view = 1;
        this.channelComment = true;
      }
    }));
    this.postDisableCheck();


    if (localStorage.getItem(REPOST_INFO_LOCAL_STORAGE.KEY) !== NUMBERS.ONE.toString() && this.feedObject?.showRepostTooltip === this.dss.reposTooltip &&
      this.feedObject?.channel?.content_visibility?.display !== NUMBERS.ZERO && this.feedObject?.channel?.content_visibility?.display !== NUMBERS.TWO) {
      this.showRepostPopOver = true;
    }

  }

  /**
   * get the post enable/disable flag.
   */
  postDisableCheck(): void {
    const checkDisableSub = this.postSer.getPostButtonStatus()
      .subscribe((res: boolean) => this.isPostButtonDisable = res);
    this.subscriptions.add(checkDisableSub);
  }

  /**
   * show comment list
   */
  showCommentList(): void {
    this.showComment = true;
  }

  /**
   * get association list of feed
   */
  getFeedAssociationList(): void {
    for (let i = 0; i < this.feedObject.user_feed_association_list?.length; i++) {
      if (i === 0) {
        this.tooltip_ass = this.feedObject.user_feed_association_list[i].association_name;
      } else {
        // Object.assign(this.cmt);
        this.tooltip_ass += ', ' + this.feedObject.user_feed_association_list[i].association_name;
      }
    }

  }

  /**
   * Reset media Modal Variable
   */
  setResetMediaModal(): void {
    // No Code
  }

  /**
   * f1
   */
  f1(): void {
    this.hide_youtube_thumbnail = true;
    const x = this.feedObject.media_list[0].media_url;
    this.youtubeUrl = x;
    this.youtubeId = x;
  }

  /**
   * f1
   */
  setYoutubeMedia(): void {
    if (this.feedObject.media_list.length == 1 && this.feedObject.media_list[0].media_type == 'youtube') {
      const x = this.feedObject.media_list[0].media_url;
      this.feedObject.media_list[0].media_thumbnail = '';
      this.feedObject.media_list[0].media_url = '';
      this.feedObject.media_list[0].media_thumbnail = 'http://img.youtube.com/vi/' + x + '/0.jpg';
      this.feedObject.media_list[0].media_url = 'https://www.youtube.com/watch?v=' + x;
    }
  }

  /**
   * product Like
   */
  productLike(): boolean {

    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (this.feed_like_loader == true) { return; }
    if (this.feedObject.like_status == 1) { return; }
    const likeData : LIKE = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.FEED,
      entity_code: this.feedObject.feed_id,
      current_screen_name: this.funCollectionService.currentScreename,
      start_time: new Date().getTime(),
      action_on : ACTION_ON.LIKE,
      action_type : ACTION_TYPE.CLICK,
      cta_type : CTA_TYPE.ENGAGEMENT_BAR,  
  }
    this.analyticSdk.analyticService.LIKE(likeData);
    this.feed_like_loader = true;
    this.subscriptions.add(this.postSer.productLike(1, this.feedObject.feed_id, 'like').subscribe(resData => {
      this.feed_like_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.funCollectionService.showSuccess(data['msg'], 'Success');
          this.feedObject.like_status = 1;
          this.feedObject.total_like = this.feedObject.total_like + 1;
          if (this.dss.isStoryLikeShareEnabled === 1) {
            this.createStoryThroughNudge(this.mls.languageText.stories_tutorial.key11, this.mls.languageText.stories_tutorial.key12, USER_STORY_NUDGE.is_story_first_like_enabled);
            this.dss.isStoryLikeShareEnabled = 0;
          }
        } else if (data['status'] == 0) {
          this.funCollectionService.showError(data['msg'], 'Error');
          this.funCollectionService.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_like_loader = false;

      });
    }));
  }

  /**
   * product Bookmark
   */
  productBookmark(): boolean {

    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (this.feed_bookmark_loader == true) { return; }
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id, this.funCollectionService.currentScreename, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK, ACTION_ON.BOOKMARK, null);
    this.feed_bookmark_loader = true;
    const action = (this.feedObject.is_bookmarked == 0) ? 'add' : 'delete';
    this.subscriptions.add(this.postSer.productBookmark(1, this.feedObject.feed_id, action).subscribe(resData => {
      this.masterService.bookmark_index.next(this.feedIdx);
      this.feed_bookmark_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.funCollectionService.showSuccess(data['msg'], 'Success');
          this.feedObj.is_bookmarked = (action == 'add') ? 1 : 0;


          if (action == 'delete') {
            this.dss.bookmarkRemove.next(this.feedIdx);
          }

        } else if (data['status'] == 0) {
          this.funCollectionService.showError(data['msg'], 'Error');
          this.funCollectionService.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_bookmark_loader = false;
      });
    }));
  }

  /**
   * feed edit
   */
  editFeed(feed: any): boolean {
    console.log(feed)
    this.dss.nextButtonEnabled = true;
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    if (feed.repost_info !== null && feed.repost_info?.is_available === NUMBERS.ZERO && feed?.repost_content === null) {
      this.funCollectionService.showError('', this.mls.languageText.feed_card_screen.key23);
      return;
    }
    this.dss.posting_data.screen1.content = feed.content;
    this.dss.posting_data.screen1.feed_kind = feed.feed_kind;
    this.dss.posting_data.screen1.is_anonymous = feed.is_anonymous;
    this.dss.posting_data.screen1.media = feed.media_list;
    this.dss.posting_data.screen1.metaData = feed.meta_array;
    this.dss.posting_data.screen1.poll = feed.poll;
    this.dss.posting_data.screen1.tag_to = feed.user_tagged;
    this.dss.posting_data.screen1.title = feed.title;
    if (this.communityId) {
       this.dss.communityExists = NUMBERS.ONE;
      }
    this.dss.posting_data.screen2.is_this_case = feed.feed_kind;
    this.dss.posting_data.screen2.selected_speciality = feed.speciality;
    this.dss.posting_data.screen3.selected_association = feed.user_feed_association_list.map(obj => obj.association_id.toString());
    // Get Topic
    this.dss.posting_data.screen5.selected_topic = feed?.t;
    this.dss.topic_community_flag = feed?.topic_community_flag;
    if(this.dss.topic_community_flag){
      this.dss.calling_from_community = NUMBERS.ONE; 
    }


    this.dss.posting_data.feed_edit_mode.is_edit = 1;
    this.dss.posting_data.screen3.selected_community = feed.community.map(obj => obj.community_id.toString());

    this.dss.posting_data.feed_edit_mode.feed_id = feed.feed_id;
    this.dss.posting_data.feed_edit_mode.feed_index = this.feedIdx;
    this.dss.temp_post_media = [];
    for (let i = 0; i < this.dss.posting_data.screen1.media.length; i++) {
      let x;
      if (this.dss.posting_data.screen1.media[i].media_type == 'image') {
        x = { media_id: this.dss.posting_data.screen1.media[i].media_id, local: this.dss.posting_data.screen1.media[i].media_url, obj: '', media_type: 'image' };
      } else if (this.dss.posting_data.screen1.media[i].media_type == 'video') {
        x = { local: this.dss.posting_data.screen1.media[i].media_thumbnail, obj: '', media_type: 'video' };
      } else if (this.dss.posting_data.screen1.media[i].media_type == 'document') {
        x = { local: this.dss.posting_data.screen1.media[i].media_thumbnail, mediaurl: this.dss.posting_data.screen1.media[i].media_url, obj: 'edit', media_type: 'document' };
      }
      this.dss.temp_post_media.push(x);
    }
    setTimeout(() => {
      this.dss.show_feed_post_modal.next(1);
    }, 500);

    if (feed.repost_content) {
      this.dss.repostProductId = this.feedObject.repost_content.product_id;
      this.dss.repostProductType = this.feedObject.repost_content.product_type;
      this.dss.isRepostStatus = REPOST_STATUS.TWO;
      this.dss.webinarRepostObject = this.feedObject.repost_content.data;
      this.dss.show_feed_post_modal.next(NUMBERS.ONE);
    }
    /**
     * analytics on clicking edit option
     * from feed
     */
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id, this.funCollectionService.currentScreename, CTA_TYPE.MORE_OPTION, ACTION_TYPE.CLICK, ACTION_ON.EDIT_POST, null);
  }

  /**
   * Get speciality aligned with feed.
   */
  getSpecialty(Sl): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id, this.funCollectionService.currentScreename, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.SPECIALITY_HASTAG, null);
    this.feedSpecialty.emit(Sl);
    this.dss.specialty_filter = Sl;
    this.router.navigate(['/web/list']);

    const dateObject = new Date();
    this.sessiontime.start_time = dateObject.getTime().toString();
  }

  /**
   * initialize meta feed
   */
  linkpost(arr): void {
    document.querySelector<HTMLInputElement>('#tempd').innerHTML = arr;
    const x = document.querySelector<HTMLInputElement>('#tempd').textContent;
    if (x != '') {
      this.meta_array = JSON.parse(x);
    }
  }

  /**
   * set style for poll feed
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMyStyles(per, poll_status, is_author): any {
    let myStyles;
    if (poll_status === 0 && !is_author) {
      myStyles = {
        'width': +'0%'
      };
    } else {
      myStyles = {
        'width': per + '%'
      };
    }
    return myStyles;
  }

  /**
   * this function will execute when user click on any poll
   */
  PollOnFeed(feed_id, option_id, poll_status): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (poll_status != 1) {
      /**
       * analytics on clicking poll from 
       * feed
       */
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id, this.funCollectionService.currentScreename, CTA_TYPE.OPTIONS, ACTION_TYPE.CLICK, ACTION_ON.POLL_ANSWER, null);
      this.subscriptions.add(this.postSer.feedPoll(feed_id, option_id).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] == 1) {
            this.feedObj.poll = data['data'].poll;
            this.feedObject.poll_status = 1;
          } else if (data['status'] == 0) {
            this.funCollectionService.errorHandeler(data);
            return;
          }
        });
      }));
    }
  }

  /**
   * feed delete
   */
  feed_delete(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.deleteFeedIdx.emit(this.feedIdx);
  }

  /**
   * this will execute when user click on delete post
   */
  onDeletePost(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.isConfirmModalShown = true;
    this.confirmInfo = this.mls.languageText.feed_card_screen.key16;
    /**
     * analytics on clicking edit option
     * from feed
     */
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id, this.funCollectionService.currentScreename, CTA_TYPE.MORE_OPTION, ACTION_TYPE.CLICK, ACTION_ON.DELETE_POST, null);

    return false;
  }

  /**
   * on clicking report post
   */
  reportPost(): void {
    /**
     * analytics on clicking edit option
     * from feed
     */
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id, this.funCollectionService.currentScreename, CTA_TYPE.MORE_OPTION, ACTION_TYPE.CLICK, ACTION_ON.REPORT, null);
  }

  /**
   * reset confirm modal
   */
  resetConfirmModal(confirmAction): void {
    this.confirmInfo = '';
    this.isConfirmModalShown = false;
    if (confirmAction === true) {
      this.feed_delete();
    }
  }

  /**
   * Event handler to show step1 delete confirmation confirmation modal
   * @param event
   * @returns
   */
  onDeleteCommunityPost(event: Event): boolean {
    event.preventDefault();
    if (this.masterService.isOnline === false) {
      this.masterService.isConnectionModalShown.next(NUMBERS.ONE);
      return false;
    }

    this.isDeleteConfirmModalStep1 = true;
    this.confirmInfo = this.mls.languageText.community.key110;
    this.deleteConfirm = {
      cancelBtnText: this.mls.languageText.community.key111,
      confirmBtnText: this.mls.languageText.community.key112
    };
    return true;
  }
  /**
   * Event handler to show step2 delete confirmation confirmation modal
   * and emits event when admin confirm
   * @param isConfirm
   * @returns
   */
  onDeleteCommunityPostConfirm(isConfirm = false): boolean {
    if (this.masterService.isOnline === false) {
      this.masterService.isConnectionModalShown.next(NUMBERS.ONE);
      return false;
    }
    if (!isConfirm) {
      return false;
    }
    if (this.isDeleteConfirmModalStep2) {
      this.isDeleteConfirmModalStep2 = false;
      if (this.isCommunityAdmin && this.feedObj.community[0].community_id) {
        const feedDeletedObj = { idx: this.feedIdx, id: this.feedObj.feed_id };
        this.emitDeleteCommunityFeed.emit(feedDeletedObj);
      }
      return;
    }

    this.isDeleteConfirmModalStep1 = false;
    this.isDeleteConfirmModalStep2 = true;
    this.confirmInfo = this.mls.languageText.community.key108;
    this.deleteConfirm = {
      cancelBtnText: this.mls.languageText.community.key113,
      confirmBtnText: this.mls.languageText.community.key114
    };
    return true;
  }

  /**
   * reset confirm modal
   */
  resetDeleteConfirmModal(confirmAction: boolean): void {
    this.confirmInfo = '';
    this.isDeleteConfirmModalStep1 = false;
    if (confirmAction) {
      this.onDeleteCommunityPostConfirm(confirmAction);
    }
  }

  /**
   * follow
   */
  caseFollow(): boolean {

    this.feed_channel_follow_loader = true;
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.followObj = '';
    this.followObj = { feed_id: this.feedObject.feed_id, status: this.feedObject.product_follow.status };
    this.is_follow = true;
  }

  /**
   * reset Follow
   */
  resetFollow(resetObj): void {
    this.feed_channel_follow_loader = false;
    if (resetObj == 1 || resetObj == 0) {
      this.feedObject.product_follow.status = resetObj;
      this.is_follow = false;
    } else {
      this.is_follow = false;
    }
  }

  /**
   * show Subscribe Popup
   */
  showSubscribePopup(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.showSubscribeModal = true;
  }

  /**
   * reset subscribe
   */
  resetProductSubscribeModal(): void {
    this.showSubscribeModal = false;
  }

  /**
   * get sample
   */
  showGetsamplePopup(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.isGetsampleModal = true;
  }

  /**
   * reset get sample
   */
  resetProductGetsampleModal(): void {
    this.isGetsampleModal = false;
  }

  /**
   * Share Data from comment
   */
  shareCommentCountToParent(process): void {
    if (process == 'add') {
      this.feedObject.total_comments = ++this.feedObject.total_comments;

    } else {
      this.feedObject.total_comments = --this.feedObject.total_comments;
    }
  }

  /**
   * see More
   */
  seeMore(): void {
    // No Code
  }

  /**
   * see Less
   */
  seeLess(): void {
    // No Code
  }

  /**
   * filter by speciality
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterBySpeciality(filterData: any): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.dss.feed_filter.next([{ 'key': 'speciality', 'value': [filterData.speciality_id] }]);
    this.funCollectionService.navigateToTop();
  }

  /**
   * navigateTo userDetail section
   */
  navigateTouser(customeId): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (this.feedObject.classification != 'pharma') {
      this.funCollectionService.navigateToUserProfie(customeId);
    } else if (this.feedObject.classification == 'pharma') {
      this.funCollectionService.navigateToChannelDetail(this.feedObject.target_id);
    }
  }

  /**
   * reset Error Modal
   */
  resetErrorModal(): void {
    this.isErrorModalShown = false;
  }

  /**
   * http Error Handeler
   */
  httpErrorHandeler(err): boolean {
    if (err.error.code == 2000) {
      this.ErrorHandler(err.error.error.msg);
      return false;
    } else if (err.error.error.code == 1002) {
      this.funCollectionService.logout();
    } else {
      this.ErrorHandler(err.error.error.msg);
      return false;
    }
  }

  /**
   * Error Handeler
   */
  ErrorHandler(Err_msg): boolean {
    this.isErrorModalShown = true;
    this.error_msg = Err_msg;
    return false;
  }

  /**
   * show Feed Detail
   */
  showFeedDetail(idx, isPostedEvent?: boolean): void {
    if (this.feedObject.repost_content != null) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id, this.funCollectionService.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.FEED, null);
    }
    else {
      const clickSub: CLICK_SUB = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.FEED,
        entity_code: this.parentFeedId,
        sub_entity_type: PRODUCT_TYPE_CONSTANT_NAME.FEED,
        sub_entity_code: this.feedObj.product_type_id,
        current_screen_name: this.funCollectionService.currentScreename,
        action_on: ACTION_ON.FEED,
        action_type: ACTION_TYPE.CLICK,
        cta_type: CTA_TYPE.SUB_CARD,
        start_time: new Date().getTime(),
        rank: 0
      }
      this.analyticSdk.analyticService.CLICK_SUB(clickSub);
    }
    if (this.feedObj.channel != null && this.feedObj.channel != '') {
      if (this.feedObj.channel.is_subscribed == 0 && this.feedObj.channel.is_product_view == 0) {
        this.channelsub = {
          docCardObj: this.feedObj.channel,
          showSubscribeModal: true,
          callingFrom: 'feedcard',
          id: this.feedObj.feed_id
        };

        this.dss.subscribeChannelCard.next(this.channelsub);
        return;
      }
    }
    this.dss.setECDetails(this.feedObject);

    if (this.funCollectionService.device_detail.is_desktop == false) {
      this.funCollectionService.navigateToFeedDetail(this.feedObj.feed_id);
    } else {
      this.mediaIdx = idx;
      this.feedDetailModal = true;
      const x = { is_show: true, feed_id: this.feedObject.feed_id, mediaIdx: idx, ecId: this.ecId, isPostedEvent };
      this.dss.showFeedDetailInModal.next(x);
    }
    /**
     * analytics on clicking feed card
     */
  }

  mediaClicked(idx,isPostedEvent?: boolean) {
    if (this.feedObject.repost_content != null) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id, this.funCollectionService.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.FEED, null);
    }
    else {
      const clickSub: CLICK_SUB = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.FEED,
        entity_code: this.parentFeedId,
        sub_entity_type: PRODUCT_TYPE_CONSTANT_NAME.FEED,
        sub_entity_code: this.feedObj.product_type_id,
        current_screen_name: this.funCollectionService.currentScreename,
        action_on: ACTION_ON.FEED,
        action_type: ACTION_TYPE.CLICK,
        cta_type: CTA_TYPE.SUB_CARD,
        start_time: new Date().getTime(),
        rank: 0
      }
      this.analyticSdk.analyticService.CLICK_SUB(clickSub);
    }
    if (this.feedObj.channel != null && this.feedObj.channel != '') {
      if (this.feedObj.channel.is_subscribed == 0 && this.feedObj.channel.is_product_view == 0) {
        this.channelsub = {
          docCardObj: this.feedObj.channel,
          showSubscribeModal: true,
          callingFrom: 'feedcard',
          id: this.feedObj.feed_id
        };

        this.dss.subscribeChannelCard.next(this.channelsub);
        return;
      }
    }
    this.dss.setECDetails(this.feedObject);

    if (this.funCollectionService.device_detail.is_desktop == false) {
      this.funCollectionService.navigateToFeedDetail(this.feedObj.feed_id);
    } else {
      this.mediaIdx = idx;
      this.feedDetailModal = true;
      const x = { is_show: true, feed_id: this.feedObject.feed_id, mediaIdx: idx, ecId: this.ecId, isPostedEvent };
      this.dss.showFeedDetailInModal.next(x);
    }

  }

  /**
   * reset Feed Detail Modal
   */
  resetFeedDetailModal(): void {
    this.mediaIdx = 0;
    this.feedDetailModal = false;
  }

  /**
   * get Product Like List
   */
  getProductLikeList(): void {
    this.likeObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'callLikeProperty': 'list', total_like: this.feedObject.total_like };
    this.showLikeListModal = true;
  }

  /**
   * reset Like
   */
  resetLike(): void {
    this.showLikeListModal = false;
  }

  /**
   * product Share
   */
  productShare(): void {
    const x = [{ share_url: this.feedObject.feed_share_url, share_contentt: this.feedObject.share_content, product_type: 1, product_type_id: this.feedObject.product_type_id }];
    this.funCollectionService.productShare(x, this.funCollectionService.currentScreename);
  }

  /**
   * reset SuggList
   */
  resetSuggList(): void {
    // No Code
  }

  /**
   * assign Association
   */
  assignAssociation(): void {
    this.dss.selected_suggAssList = [];
    this.subscriptions.add(this.postSer.assignAssociation('association', '[]', '', 0).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          if (data['code'] == 2000) {
            this.displayObj.isShow = true;
            this.displayObj.display_section = 'verificationSuccess';
            this.displayObj.data = data['data'];
            this.displayObj.errObj = [];
            this.masterService.showWebModal.next(this.displayObj);
          }
        } else {
          this.funCollectionService.errorHandeler(data);
          return;
        }
      });
    }));
  }

  /**
   * reset Comment
   */
  resetComment(): void {
    this.feedObject.total_comments = this.feedObject.total_comments + 1;
  }


  /**
   *
   * checks if the post is part of Editor's choice
   * @readonly
   * @type {boolean}
   * @memberof FeedCardComponent
   */
  get isEditorsChoicePost(): boolean {
    return (this.feedObj.editor_choice_data && NUMBERS.ONE === this.feedObj.editor_choice_data.is_ec_product);
  }
  /**
   * returns the value of calling from
   */
  get isEditorsChoiceList(): boolean {
    return (this.callingfrom === CALLING_FROM.EC_DETAIL);
  }
  /**
   * Unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.notifier$.next();
    this.notifier$.complete();
  }
  /**
   * Emit user comment.
   */
  emitComment(data: userComment): void {
    this.emitUserComment = data;
  }
  /**
   *  Reset comment list.
   */
  resetCmtList(): void {
    // No Code
  }

  /**
   * Delete total reply comments.
   */
  deleteTotalReplyComment(replyCount): void {
    this.feedObject.total_comments = this.feedObject.total_comments - replyCount;
  }

  /**
   * getter for postedIn details
   */
  get postedIn(): PostedIn {
    if (!this.feedObject) {
      return null;
    }
    return this.funCollectionService.getPostedInDetail(this.feedObject);
  }

  /**
   * event handler for open feed detail
   * @param event
   */
  handleOpenFeedEvent(): void {
    this.showFeedDetail(0, true);
  }

  /**
   * event handler for community detail navigation
   * @param community_id
   */
  handleCommunityDetailEvent(community_id: string): void {
    this.funCollectionService.navigateToCommunityDetailAndReload(community_id);
  }
  /**
   * feed repost as story
   */
  feedRepostAsStory(): void {
    if(this.feedObject.repost_info !== null && this.feedObject.repost_info?.is_available === NUMBERS.ZERO){
      this.funCollectionService.showError('', this.mls.languageText.feed_card_screen.key18);
      return;
    } else if (this.feedObject.repost_info !== null && this.feedObject.repost_content?.data?.channel !== null && this.feedObject.repost_content?.data?.channel?.content_visibility?.display !== NUMBERS.ONE) {
      this.funCollectionService.showError('', this.mls.languageText.feed_card_screen.key21);
      return;
    }
    if (this.feedObject.repost_content === null) {
      this.dss.user_story_productTypeId = this.feedObj.product_type_id;
      this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.FEED;
      this.dss.create_Story_productData.next(this.feedObj); 
    }
    else {
      this.dss.create_Story_productData.next( this.feedObject.repost_content.data);
      this.dss.user_story_productTypeId = this.feedObject.repost_content.product_id;
      this.dss.user_story_productType = this.feedObject.repost_content.product_type;
    }
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
    this.dss.storyType = CREATE_STORY_TYPES.REPOST;
    this.dss.create_Story.next(true);
  }
    /**
   * create story through nudge
   */
    createStoryThroughNudge(storyNudgeHeading, storyNudgeDisc, nudgeType ): void {
      this.dss.create_Story_productData.next(this.feedObj);
      this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.FEED;
      this.dss.user_story_productTypeId = this.feedObj.product_type_id;
      this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
      this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
      this.dss.storyType = CREATE_STORY_TYPES.REPOST;
      this.dss.storyNudgeIcon = 'assets/images/webinar-nudge.png';
      this.dss.storyNudgeHeading = storyNudgeHeading;
      this.dss.storyNudgeDisc = storyNudgeDisc,
      this.dss.storyNudgeButton = this.mls.languageText.stories_tutorial.key16;
      this.dss.story_nudge_type = nudgeType;
      this.dss.userStoryNudge.next(true);
    }
  /**
   * generate feed repost option meta
   */
  feedRepostOption(): void {
    this.funCollectionService.checkRepostPopOver(this.feedObject?.topic_community_flag,this.feedObject?.channel?.community_id, this.feedObject?.hl?.tcf);
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id,this.funCollectionService.currentScreename, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK, ACTION_ON.REPOST, null);
    this.isMetaGenerated = true;
  }
  /**
   * close posting meta
   */
  closeMeta(event): void{
    this.funCollectionService.isShowFeedRepost = true;
    this.isMetaGenerated = false;
  }
  /**
   *
   * @param event repost functionality
   */
  repostFeedType(event): void {
    if (event === REPOST_TYPE_ITEM.REPOST_ON_FEED) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id,
        this.funCollectionService.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_FEED, null);
      this.feedRepost();
    }
    else if (event === REPOST_TYPE_ITEM.REPOST_AS_STORY) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObj.product_type_id,
        this.funCollectionService.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_STORY, null);
      if (this.dss.user_profile_data.profile.permission != 'all') {
        this.funCollectionService.assignAssociation('');
        return;
      }
      this.feedRepostAsStory();
    }
  }
  /**
   * Feed repost.
   */
  feedRepost(edit?): void {
    if (this.dss.post_process_obj.status === POSTING_PROGRESS.IN_PROGRESS) {
      this.funCollectionService.showError('', this.mls.languageText.feed_card_screen.key22);
      return;
    }
    if (this.feedObject.repost_info !== null && this.feedObject.repost_info?.is_available === NUMBERS.ZERO) {
      this.funCollectionService.showError('', this.mls.languageText.feed_card_screen.key18);
    } else if (this.feedObject.repost_info !== null && this.feedObject.repost_content?.data?.channel !== null && this.feedObject.repost_content?.data?.channel?.content_visibility?.display !== NUMBERS.ONE) {
      this.funCollectionService.showError('', this.mls.languageText.feed_card_screen.key21);
    } else if (this.feedObject.repost_content === null) {
      this.dss.repostProductId = this.feedObj.product_type_id;
      this.dss.repostProductType = PRODUCT_TYPE_CONSTANT.FEED;
      this.dss.isRepostStatus = REPOST_STATUS.ONE;
      this.funCollectionService.navigateToFeedDetail(NUMBERS.ZERO);
      this.dss.show_feed_post_modal.next(NUMBERS.ONE);
      this.dss.webinarRepostObject = this.feedObj;
      if (this.feedObj.user_profile?.custom_id && this.feedObj.user_profile?.custom_id !== this.dss.user_profile_data?.profile?.custom_id && this.dss.user_profile_data?.profile?.permission === 'all') {
        this.dss.tagedUser.push(this.feedObj.user_profile);
        this.dss.posting_data.screen1.tag_to.push(this.feedObj.user_profile);
      }
    } else {
      this.dss.repostProductId = this.feedObject.repost_content.product_id;
      this.dss.repostProductType = this.feedObject.repost_content.product_type;
      this.dss.isRepostStatus = REPOST_STATUS.ONE;
      this.funCollectionService.navigateToFeedDetail(NUMBERS.ZERO);
      this.dss.show_feed_post_modal.next(NUMBERS.ONE);
      this.dss.webinarRepostObject = this.feedObject.repost_content.data;
      if (this.feedObject.repost_content.product_type === NUMBERS.ONE && this.feedObj.repost_content.data.user_profile?.custom_id && edit !== 'edit' &&
        this.feedObj.repost_content.data.user_profile?.custom_id !== this.dss.user_profile_data?.profile?.custom_id && this.dss.user_profile_data?.profile?.permission === 'all') {
        this.dss.tagedUser.push(this.feedObj.repost_content.data.user_profile);
        this.dss.posting_data.screen1.tag_to.push(this.feedObj.repost_content.data.user_profile);
      }

    }

    if (this.showRepostPopOver) {
      this.subscriptions.add(this.postSer.logTutorialView('repost').subscribe(() => {
        // No Code
      })
      );
    }
    this.showRepostPopOver = false;
    this.setLocalStorageIsRepostPopover();
  }

  closeTagTutorial(): void {
    this.showRepostPopOver = false;
    this.setLocalStorageIsRepostPopover();
    this.subscriptions.add(this.postSer.logTutorialView('repost').subscribe(() => {
      // No Code
    })
    );
  }

  /**
   * Set the repost info popover status in local storage.
   */
  setLocalStorageIsRepostPopover(): void {
    localStorage.setItem(REPOST_INFO_LOCAL_STORAGE.KEY, REPOST_INFO_LOCAL_STORAGE.VALUE);
  }

  /**
  * For pinning and unpinning the post
  */
  pinUnpinPost(productId: number, isPinned: number): void {
    this.subscriptions.add(this.postSer.pinUnpinPost(this.communityId, productId, isPinned ? NUMBERS.ZERO : NUMBERS.ONE, this.productType.FEED).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] === NUMBERS.ONE) {
          window.location.reload();
        } else if (data['status'] === NUMBERS.ZERO) {
          this.funCollectionService.showError(data['msg'], 'Error');
          this.funCollectionService.errorHandeler(data);
          return;
        }
      });
    }));
  }

  redirectToCommunityDetail(code):void {
      this.funCollectionService.navigateToCommunityDetailPage(code);
  }

}

